import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Task Manager';
  menu:string = 'menu-wrapper';

  toggleMenu() {
    this.menu = (this.menu == 'menu-show') ? 'menu-wrapper' : 'menu-show';
    console.log('MENU: '+this.menu);
  }
}



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/app.component.ts